<template lang="pug">
  FormModal(title="New Heading", endpoint="blocks", :data="data", v-bind="$attrs", @success="onSuccess")
    InputGroup(name="title")
      TextInput(v-model="data.title", prepend-icon="block-heading", auto-focus)
    InputGroup(v-if="!collection_id", name="collection_ids", label="Collection(s) - optional", description="Click the chevron or your down arrow key to see list")
      MultiSelect(v-model="data.collection_ids", placeholder="Add this to a collection...", endpoint="options/all/collections", option-label="label")
</template>

<script>
export default {
  props: {
    collection_id: {
      type: Number
    }
  },
  data: () => ({
    data: {
      collection_id: null,
      collection_ids: [],
      block_type: "heading",
      title: ""
    }
  }),
  created() {
    this.data.collection_id = this.collection_id
  },
  methods: {
    onSuccess(result) {
      this.$notification.success(`Heading successfully created.`)
      this.$emit("close", result)
    }
  }
}
</script>
